module.exports = __webpack_public_path__ + "files/0e73c68fce2747d3643b09ba2515c7a2.png";